module.exports = __webpack_public_path__ + "static/media/cleo-mobile-411x93@2x.3eba6f58.jpg";